export const userTypes = {
  rider: "rider",
  customer: "customer",
  admin: "super-admin",
};
